import { Country, AreAgeAndCareerPathVisibleQuery, AreAgeAndCareerPathVisibleQueryVariables } from '../../types'
import { QueryResult, useQuery } from '@apollo/client'
import { ARE_AGE_AND_CAREERPATH_VISIBLE } from '../../graphql/countrySettings/Queries'

export const useAreAgeAndCareerPathVisible = (
  country: Country,
): QueryResult<AreAgeAndCareerPathVisibleQuery, AreAgeAndCareerPathVisibleQueryVariables> => {
  return useQuery<AreAgeAndCareerPathVisibleQuery, AreAgeAndCareerPathVisibleQueryVariables>(ARE_AGE_AND_CAREERPATH_VISIBLE, {
    variables: { country },
    fetchPolicy: 'network-only',
  })
}
